export { AgesPieChart } from './AgesPieChart';
